import Box from '@mui/material/Box';
import Step from '@mui/material/Step';
import StepButton from '@mui/material/StepButton';
import StepLabel from '@mui/material/StepLabel';
import Stepper from '@mui/material/Stepper';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { ONBOARDING_STEPS } from '../utils/onboardingSteps.config';
import { useWizard } from '../hooks/WizardProvider';
import { canNavigateToStep } from '../utils/stepNavigation';
import useOnboardingSx from '../hooks/useOnboardingSx';

export default function StepperNav() {
  const theme = useTheme();
  const sx = useOnboardingSx();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { currentStep, steps, goToStep } = useWizard();

  return (
    <Box sx={sx.stepper}>
      <Stepper
        activeStep={currentStep - 1}
        orientation={isMobile ? 'horizontal' : 'vertical'}
        alternativeLabel={isMobile}
        sx={isMobile ? sx.stepperHorizontal : sx.stepperVertical}
      >
        {ONBOARDING_STEPS.map((step) => {
          const status = steps[step.key];
          const canGo = canNavigateToStep(step.id, steps);
          return (
            <Step key={step.key} completed={status === 'completed'}>
              {canGo ? (
                <StepButton onClick={() => goToStep(step.id)} sx={sx.stepButton}>
                  <StepLabel
                    optional={
                      !step.required ? (
                        <Typography variant="caption">Optional</Typography>
                      ) : status === 'skipped' ? (
                        <Typography variant="caption">Skipped</Typography>
                      ) : null
                    }
                  >
                    {step.title}
                  </StepLabel>
                </StepButton>
              ) : (
                <StepLabel
                  optional={
                    !step.required ? <Typography variant="caption">Optional</Typography> : null
                  }
                >
                  {step.title}
                </StepLabel>
              )}
            </Step>
          );
        })}
      </Stepper>
    </Box>
  );
}
